import { useState } from 'react';
import { Box, Dialog, Link, Typography } from '@mui/material';
import { Typography as JoyTypography } from '@mui/joy';
import { BasicModalContent } from '@dreebit-registry/vsm-microservice-components';
import { HelpOutlined } from '@mui-symbols-material/w300';
import { useTranslation } from 'react-i18next';

const IframeTroubleshootingLink = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleClose = () => setOpen(false);

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                px: 1.5,
                py: 0.5,
            }}
        >
            <Link
                component="button"
                type="button"
                underline="hover"
                onClick={() => setOpen(true)}
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    fontSize: '0.8125rem',
                    color: 'text.secondary',
                }}
            >
                <HelpOutlined sx={{ fontSize: 16 }} />
                {t('Content not loading?')}
            </Link>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <BasicModalContent
                    onClose={handleClose}
                    title={
                        <JoyTypography level="titleSmallLight" sx={{ fontWeight: 'bold' }}>
                            {t('Content not loading?')}
                        </JoyTypography>
                    }
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, p: 2, minWidth: 400 }}>
                        <Typography>
                            {t('The embedded content is loaded from a different domain and needs third-party cookies to keep your session.')}
                        </Typography>
                        <Typography>
                            {t('If you see a blank area, a login page, or a connection error, your browser is most likely blocking third-party cookies for this site.')}
                        </Typography>
                        <Typography>
                            {t('How to enable third-party cookies')}
                        </Typography>
                        <Box component="ul" sx={{ pl: 3, m: 0 }}>
                            <Typography component="li">
                                {t('Chrome / Edge: Settings → Privacy and security → allow third-party cookies (or add this site as an exception).')}
                            </Typography>
                            <Typography component="li">
                                {t('Firefox: Settings → Privacy & Security → set Enhanced Tracking Protection to Custom and allow cookies for this site.')}
                            </Typography>
                            <Typography component="li">
                                {t('Safari: Settings → Privacy → disable "Prevent cross-site tracking".')}
                            </Typography>
                        </Box>
                        <Typography>
                            {t('After changing the setting, reload the page.')}
                        </Typography>
                    </Box>
                </BasicModalContent>
            </Dialog>
        </Box>
    );
};

export default IframeTroubleshootingLink;
